import { createEmojiIcon } from '@r1-frontend/ui-react/components/emoji/createEmojiIcon';

const Cookie = 127850;

export default createEmojiIcon(Cookie);
